import { Popup } from 'styleguide/components/popup'
import { isMobile } from 'core/services/browser'

export class RedeemReferral {
  constructor(private container: Element) {
    if (!isMobile()) {
      this.initSendToPhone()
    }

    this.initWazersAnimation()
    this.initOpenAndroidAppScreenButtons()
  }

  private initSendToPhone() {
    const el = this.container.querySelector('.wz-popup-overlay') as HTMLElement
    const buttons = this.container.querySelectorAll('.referral-send-to-phone button') as NodeListOf<
      HTMLElement
    >
    if (el && buttons) {
      const popup = new Popup(el)

      buttons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault()
          popup.show()
        })
      })
    }
  }

  private initOpenAndroidAppScreenButtons() {
    const openAndroidAppScreenButtons = this.container.querySelectorAll(
      '.js-android-screen'
    ) as NodeListOf<HTMLElement>

    const showAndroidAppScreen = (e: any) => {
      const app = e.currentTarget.getAttribute('data-app')

      if (document.location.search.includes('skip-android=true')) {
        const androidDeeplink = (document.querySelector(
          `.${app}-android-deeplink-btn`
        ) as HTMLAnchorElement).href
        const androidPlaystore = (document.querySelector(
          `.${app}-playstore-btn`
        ) as HTMLAnchorElement).href

        document.location.href = androidDeeplink
        setTimeout(function() {
          document.location.href = androidPlaystore
        }, 300)
      } else {
        document.body.classList.add(`ul-android-screen--${app}--visible`)
      }
    }

    openAndroidAppScreenButtons.forEach(b => b.addEventListener('click', showAndroidAppScreen))
  }

  private initAnimation(container: Element) {
    const wazersNumber = 5
    const wazerTimeMs = 1750
    const current: { [key: string]: number } = {
      left: 0,
      right: 0
    }

    const getWazer = (side: string, i: number) => {
      return container.querySelector(`.wazer-${side}.wazer-${i}`) as HTMLElement
    }

    const showWazer = (side: string, i: number) => {
      const wazer = getWazer(side, i)
      wazer.classList.remove('wazer-animation-hidden')
      wazer.classList.add('wazer-animation-visible')
    }

    const hideWazer = (side: string, i: number) => {
      const wazer = getWazer(side, i)
      wazer.classList.remove('wazer-animation-visible')
      wazer.classList.add('wazer-animation-hidden')
    }

    const next = (side: string) => {
      hideWazer(side, current[side])
      current[side] += 1
      if (current[side] >= wazersNumber) {
        current[side] = 0
      }
      showWazer(side, current[side])
    }

    setInterval(() => next('left'), wazerTimeMs)
    setTimeout(() => setInterval(() => next('right'), wazerTimeMs), wazerTimeMs / 2)
  }

  private initWazersAnimation() {
    const animationContainer = this.container.querySelector('.ul-wazers-animation')
    if (animationContainer) {
      this.initAnimation(animationContainer)
    }
  }
}
